import { Pipe, PipeTransform } from '@angular/core';
import { DictionaryService } from '../services/dictionary/dictionary.service';

@Pipe({
  name: 'textmapper'
})
export class TextMapperPipe implements PipeTransform {
  constructor(private dictionaryService: DictionaryService) {}
  transform(value: any, key?: any): any {
    return this.dictionaryService.mapValue(key, value);
  }
}
